(function() {
    'use strict';
    angular
        .module('jmrsignApp')
        .factory('DocumentVersionPage', DocumentVersionPage);

    DocumentVersionPage.$inject = ['$resource'];

    function DocumentVersionPage ($resource) {
        var resourceUrl =  'api/document-version-pages/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
